<template>
<div v-loading="carregando">
    <el-row :gutter="15">

        <!-- Catálogo completo vindo da API externa -->
        <el-col :xs="24" :sm="10" :md="9">
            <h4 class="u-mb-10">Catálogo do RH ({{ catalogoFiltrado.length }} de {{ catalogo.length }})</h4>

            <el-input v-model="busca" clearable placeholder="Pesquisar por código ou descrição" class="u-mb-10">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>

            <div class="container-table" style="max-height: 480px; overflow-y: auto;">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 70px;">Código</th>
                            <th>Descrição</th>
                            <th style="width: 60px;" class="u-text-center">Incluir</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in catalogoFiltrado" :key="item.codigo">
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.descricao }}</td>
                            <td class="u-text-center">
                                <el-button v-if="!estaSelecionado(item.codigo)" @click="incluir(item)"
                                    type="primary" icon="el-icon-plus" size="mini" plain title="Incluir na grade"></el-button>
                                <i v-else class="el-icon-check" style="color: #67c23a; font-size: 18px;"></i>
                            </td>
                        </tr>
                        <tr v-if="!catalogoFiltrado.length">
                            <td colspan="3" class="u-text-center">Nenhum evento encontrado.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </el-col>

        <!-- Eventos que ficarão na grade -->
        <el-col :xs="24" :sm="14" :md="15">
            <h4 class="u-mb-10">Exibidos na grade ({{ selecionados.length }})</h4>

            <div class="u-text-right u-mb-10">
                <el-button @click="salvar" type="primary" size="small" icon="el-icon-check" :disabled="!alterado">
                    SALVAR
                </el-button>
            </div>

            <div class="container-table" style="max-height: 480px; overflow-y: auto;">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 60px;">Código</th>
                            <th>Descrição</th>
                            <th style="width: 110px;">Digitação</th>
                            <th style="width: 140px;" title="Como as horas são escritas no arquivo TXT enviado ao RH">Horas no arquivo</th>
                            <th style="width: 70px;" class="u-text-center" title="Campo exibido, mas não digitável">Só leitura</th>
                            <th style="width: 80px;" class="u-text-center" title="Sai como coluna no Relatório de Ponto">No relatório</th>
                            <th style="width: 80px;" class="u-text-center" title="Vai para o arquivo TXT de eventuais enviado ao RH">No arquivo</th>
                            <th style="width: 90px;" class="u-text-center">Ordem</th>
                            <th style="width: 50px;" class="u-text-center">-</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in selecionados" :key="item.codigo">
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.descricao }}</td>
                            <td>
                                <el-select v-model="item.tipo_lancamento" size="mini" style="width: 100%;" @change="alterado = true">
                                    <el-option label="Horas" value="H"></el-option>
                                    <el-option label="Dias" value="D"></el-option>
                                    <el-option label="Valor" value="V"></el-option>
                                </el-select>
                            </td>
                            <td>
                                <!-- Só em horas: dias e valor já vão em decimal, não há escolha. -->
                                <el-select v-if="item.tipo_lancamento === 'H'" v-model="item.formato_horas"
                                    size="mini" style="width: 100%;" @change="alterado = true">
                                    <el-option label="hh:mm (1,30)" value="HHMM"></el-option>
                                    <el-option label="Decimal (1,50)" value="DECIMAL"></el-option>
                                </el-select>
                                <span v-else style="display: block;" class="u-text-center">-</span>
                            </td>
                            <td class="u-text-center">
                                <el-switch v-model="item.somente_leitura" @change="alterado = true"></el-switch>
                            </td>
                            <td class="u-text-center">
                                <el-switch v-model="item.no_relatorio" @change="alterado = true"></el-switch>
                            </td>
                            <td class="u-text-center">
                                <el-switch v-model="item.exporta" @change="alterado = true"></el-switch>
                            </td>
                            <td class="u-text-center">
                                <el-button @click="mover(i, -1)" :disabled="i === 0" icon="el-icon-top" size="mini" plain title="Subir"></el-button>
                                <el-button @click="mover(i, 1)" :disabled="i === selecionados.length - 1" icon="el-icon-bottom" size="mini" plain title="Descer"></el-button>
                            </td>
                            <td class="u-text-center">
                                <el-button @click="remover(i)" type="danger" icon="el-icon-delete" size="mini" plain title="Remover da grade"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!selecionados.length">
                            <td colspan="9" class="u-text-center">Nenhum evento selecionado.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </el-col>
    </el-row>
</div>
</template>

<script>
// Curadoria dos eventos exibidos na aba Folha do lançamento. O catálogo (centenas
// de eventos) vem do SIP; o banco local guarda só o que está habilitado, a ordem,
// a forma de digitação e o comportamento no relatório.
export default {
    name: 'AbaEventosGrade',
    data: () => ({
        carregando: true,
        alterado: false,
        busca: '',
        catalogo: [],
        selecionados: []
    }),
    computed: {
        catalogoFiltrado () {
            const termo = (this.busca || '').trim().toUpperCase()
            if (!termo) return this.catalogo
            return this.catalogo.filter(e => e.codigo.indexOf(termo) === 0 || e.descricao.toUpperCase().indexOf(termo) !== -1)
        }
    },
    mounted () {
        this.getCatalogo()
    },
    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },
        getCatalogo () {
            this.carregando = true
            this.$axios.get(`${this.baseUrl()}/evento-habilitado/catalogo`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.catalogo = res.data || []
                    this.selecionados = this.catalogo
                        .filter(e => e.habilitado)
                        .sort((a, b) => a.ordem - b.ordem)
                        .map(e => ({
                            codigo: e.codigo,
                            descricao: e.descricao,
                            tipo_lancamento: e.tipo_lancamento || 'H',
                            formato_horas: e.formato_horas || 'DECIMAL',
                            somente_leitura: !!e.somente_leitura,
                            no_relatorio: e.no_relatorio !== false,
                            exporta: e.exporta !== false,
                            legenda: e.legenda || ''
                        }))
                    this.alterado = false
                    this.carregando = false
                })
                .catch(e => { this.carregando = false; this.$emit('erro', e) })
        },
        estaSelecionado (codigo) {
            return this.selecionados.some(e => e.codigo === codigo)
        },
        incluir (item) {
            if (this.estaSelecionado(item.codigo)) return
            this.selecionados.push({
                codigo: item.codigo,
                descricao: item.descricao,
                tipo_lancamento: item.tipo_lancamento || 'H',
                formato_horas: 'DECIMAL',
                somente_leitura: false,
                no_relatorio: true,
                exporta: true,
                legenda: ''
            })
            this.alterado = true
        },
        remover (i) {
            this.selecionados.splice(i, 1)
            this.alterado = true
        },
        mover (i, direcao) {
            const destino = i + direcao
            if (destino < 0 || destino >= this.selecionados.length) return
            const item = this.selecionados.splice(i, 1)[0]
            this.selecionados.splice(destino, 0, item)
            this.alterado = true
        },
        salvar () {
            const itens = this.selecionados.map((e, i) => ({
                evento_cod: e.codigo,
                tipo_lancamento: e.tipo_lancamento,
                formato_horas: e.formato_horas || 'DECIMAL',
                somente_leitura: !!e.somente_leitura,
                no_relatorio: !!e.no_relatorio,
                exporta: !!e.exporta,
                // A legenda saiu da tela, mas continua indo no payload: sem isso o
                // que já foi configurado seria apagado no primeiro salvamento.
                legenda: e.legenda || '',
                ordem: i + 1
            }))

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.baseUrl()}/evento-habilitado/salvar`, { itens }, this.$store.getters.getHeaderAuth)
                .then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                    this.getCatalogo()
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$emit('erro', e) })
        }
    }
}
</script>
